// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"210":"people","385":"place","535":"login","587":"community","966":"dashboard"}[chunkId] + "." + {"210":"8cee2d1b","385":"c68b604c","535":"7505568d","587":"53739f1c","966":"8cee2d1b"}[chunkId] + ".css";
};